import { render, staticRenderFns } from "./DocumentTemplateDetails.vue?vue&type=template&id=53672b7d"
import script from "./DocumentTemplateDetails.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports